"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import FloatingOnlineChat from "@/components/onlineChat/floatingOnlineChat";
import { getOnlineChatSettings } from "@/services/onlineChat.service";

type OnlineChatSwitcherProps = {
  isLoggedIn: boolean;
};

export default function OnlineChatSwitcher({
  isLoggedIn,
}: OnlineChatSwitcherProps) {
  const [useInternalChat, setUseInternalChat] = useState(false);
  const [isResolved, setIsResolved] = useState(false);

  useEffect(() => {
    let ignore = false;

    getOnlineChatSettings()
      .then((response) => {
        if (!ignore) {
          setUseInternalChat(Boolean(response.data?.online_chat_enabled));
        }
      })
      .catch(() => {
        if (!ignore) {
          setUseInternalChat(false);
        }
      })
      .finally(() => {
        if (!ignore) {
          setIsResolved(true);
        }
      });

    return () => {
      ignore = true;
    };
  }, []);

  if (!isResolved) {
    return null;
  }

  if (useInternalChat) {
    return <FloatingOnlineChat />;
  }

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Script
      id="muchat-agent"
      type="module"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `import Chatbox from 'https://cdn.mu.chat/embeds/dist/chatbox/index.js?v=2';

Chatbox.initBubble({
  agentId: 'cmlg8r2b100gfvzmhhk6jxwmb',
});`,
      }}
    />
  );
}
